import { Header } from './components/Header';
import { About } from './components/About';
import contentData from './assets/data/contentData';
import './App.css';
import { Contact } from './components/Contact';
import { Projects } from './components/Projects';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header contentData={contentData} />
      <About contentData={contentData} />
      <Projects contentData={contentData} />
      <Contact contentData={contentData} />
      <Footer contentData={contentData} />
    </div>
  );
}

export default App;
